import React, { useState, useRef, useEffect } from 'react';

/**
 * Type-to-search item picker. Replaces a plain <Select> so users can filter the
 * full item master by name / code while adding invoice / sales-order line items.
 */
export function ItemSearchSelect({ items, value, displayName, onSelect, testId, placeholder = 'Select item...' }) {
  const [open, setOpen] = useState(false);
  const [q, setQ] = useState('');
  const ref = useRef(null);

  useEffect(() => {
    const onDocClick = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener('mousedown', onDocClick);
    return () => document.removeEventListener('mousedown', onDocClick);
  }, []);

  const filtered = (items || []).filter((it) => {
    if (!q) return true;
    const s = q.toLowerCase();
    return (
      (it.name || '').toLowerCase().includes(s) ||
      (it.product_code || '').toLowerCase().includes(s) ||
      (it.sku || '').toLowerCase().includes(s)
    );
  }).slice(0, 60);

  return (
    <div className="relative" ref={ref}>
      <button
        type="button"
        onClick={() => { setOpen((o) => !o); setQ(''); }}
        className="w-full text-left text-xs h-8 px-2 border border-gray-200 rounded-md flex items-center justify-between bg-white hover:border-gray-300"
        data-testid={testId}
      >
        <span className={`truncate ${displayName ? 'text-[#0B1B3D]' : 'text-gray-400'}`}>{displayName || placeholder}</span>
        <span className="text-gray-400 ml-1 shrink-0">▾</span>
      </button>
      {open && (
        <div className="absolute z-50 left-0 mt-1 w-[300px] max-w-[90vw] bg-white border border-gray-200 rounded-md shadow-lg" data-testid={`${testId}-dropdown`}>
          <div className="p-2 border-b border-gray-100">
            <input
              autoFocus
              value={q}
              onChange={(e) => setQ(e.target.value)}
              placeholder="Type to search items..."
              className="w-full px-2 py-1.5 text-xs border border-gray-200 rounded focus:outline-none focus:ring-1 focus:ring-[#0B1B3D]"
              data-testid={`${testId}-search`}
            />
          </div>
          <div className="max-h-60 overflow-y-auto">
            {filtered.length === 0 ? (
              <div className="px-3 py-2 text-xs text-gray-400">No items found</div>
            ) : (
              filtered.map((it) => (
                <div
                  key={it.id}
                  onClick={() => { onSelect(it.id); setOpen(false); }}
                  className={`px-3 py-2 text-xs hover:bg-gray-50 cursor-pointer border-b border-gray-50 last:border-0 ${it.id === value ? 'bg-gray-50' : ''}`}
                  data-testid={`${testId}-option-${it.id}`}
                >
                  <span className="font-medium text-[#0B1B3D]">{it.name}</span>
                  {(it.product_code || it.sku) && (
                    <span className="text-gray-400 ml-1">({it.product_code || it.sku})</span>
                  )}
                </div>
              ))
            )}
          </div>
        </div>
      )}
    </div>
  );
}
